<template>
  <div id="app"><router-view v-if="isRouterAlive" /></div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  watch: {
    //监听路由变化
    $route() {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    }
  },
  created() {
    if (location.hostname != "localhost" && location.hostname !== "127.0.0.1") {
      if (location.protocol !== "https:") {
        window.location.href = "https://winielts.com/";
      }
    }
  }
};
</script>
<style lang="stylus">
body
  font:14px/1.5 -apple-system,"San Francisco","Helvetica Neue",Arial,"Segoe UI","PingFang SC","Hiragino Sans GB",STHeiti,"Microsoft Yahei","Microsoft JhengHei","Source Han Sans SC","Noto Sans CJK SC","Source Han Sans CN","Noto Sans SC","Source Han Sans TC","Noto Sans CJK TC","WenQuanYi Micro Hei","驿微米黑",SimSun,sans-serif;
h1
  font-weight bold
/*p,span,a,div,li*/
#app
  width 100%
  height 100%
  background-color #fff
</style>



// WEBPACK FOOTER //
// src/App.vue